module.exports = __webpack_public_path__ + "img/customer_cqdz.ace643a5.svg";